export default __webpack_public_path__ + "static/media/recycleGray.c76d6382.svg";